<template>
    <div class="pb-5">
        <top-bar activeTab="campaign"
                :showBack="true"
                :lbl="lbl"
                :profile="profile"
                :isLogin="isLogin"
                :title="cateName"
                @onClickBack="Clickback()"></top-bar>
       <div class="list-campaign"
            v-if="isLoaded && isHaveItem">
            <div v-for="(campaign, k) in campaigns"
                :key="k" :index="k">
                <div class="campaign-wrapper">
                    <div class="campaign-service-name" >{{campaign.name}}</div>
                    <div class="campaign-detail">{{campaign.detail}}</div>
                    <div class="campaign-price">
                        <div class="icon-time">
                            <div> <img src="../assets/icon/time-svgrepo-com@3x.png" /></div>
                            <div class="price px-2">{{campaign.caption}}</div>
                            <div class="price">{{lbl.date.minutes_short2}}</div>
                        </div>
                        <div class="icon-price">
                            <div> <img src="../assets/icon/price-tag-svgrepo-com@3x.png" /></div>
                            <div class="price px-2">{{getFormatnumber(campaign.pricePerUnit)}}</div>
                        </div>
                    </div>

                    <div class="booking-btn-wrapper">
                        <div class="booking-btn" @click="clickRedeem(campaign)">
                            {{campaign.customCaption ? campaign.customCaption : lbl.detail.booking_now}}
                        </div>
                    </div>

                    <div class="border-item"> <img src="../assets/icon/line-2@3x.png"/> </div>
                </div>
            </div>
        </div>
        <SelectBookingService
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busSelectService"
            :errorMessage="errorMessage"
            @clickConfirmRedeemService="clickConfirmRedeemService($event)"
            @clickCancelSelectStore="clickCancelSelectStore($event)"
            ></SelectBookingService>
        <modal view="campaign-list"
            :busModal="busModal"></modal>
        <serial-modal
            :lbl="lbl"
            :busSerialModal="busSerialModal"></serial-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper";
//service
import BzbsCampaign from "@/service/BzbsCampaign.js";
import DiorApi from "@/service/dior/DiorApi.js";
import {
    CampaignListConfigBuilder
} from "@/service/config/CampaignConfigModel.js";
import Locale from '@/helper/locale/locale.js';

import TopBar from '@/components/TopBar.vue';
import Utility from '../helper/Utility';
//modal
import Modal from '@/components/modal/Modal.vue';
import SelectBookingService from '@/components/modal/SelectBookingService.vue';
import SerialModal from '@/components/modal/SerialModal.vue';

export default {
    name: 'CampaignService',
    components: {
        TopBar,
        Modal,
        SelectBookingService,
        SerialModal,
    },
    props: {

    },
    data: function() {
        return {
            strConfigList: '',
            cateId: '',
            isLoaded: false,
            isHaveItem: false,
            isLogin: false,

            profile: {},
            profileDior: {},
            lbl: Locale.getLbl(),

            busModal: new Vue(),
            busSelectService: new Vue(),
            busSerialModal: new Vue(),
            cateName: '',
            campaign: null,
            errorMessage: null,

            objRedeemInfoConfig: {},
            tracking: new TrackingService(this),
            userId: Account.getLineUserId()
        }
    },
    created: function() {
        this.cateName = this.$route.params.catename;
        this.cateId = this.$route.params.cateId;
        this.strConfigList = this.$route.params.configlist;

        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
            this.profileDior = Account.getCacheDiorProfile();
        });
    },
    mounted: function () {
        this.initialCampaign();
        this.getList();
        this.initialLoadMore();
    },
    methods: {
        clickRedeem: function (campaign) {
            this.campaign = campaign;
            this.$nextTick().then( () => {
                this.busSelectService.$emit('showSelectBookingModal', {});
            });
            let trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
            this.tracking.event('service_list', 'click_ServiceBooking', trackCamp);
        },
        clickCancelSelectStore: function () {
            this.errorMessage = null;
        },
        clickConfirmRedeemService: function (dataInfo) {

            this.showLoading();
            this.objRedeemInfoConfig.dataInfo = dataInfo.dataInfo;
            var bzbsToken = Account.getToken();
            DiorApi.bookingDior(bzbsToken, this.objRedeemInfoConfig.dataInfo)
                .then((campaign) => {

                    if (campaign.data.Status == "000" ||
                        campaign.data.Status ==  "001" ||
                        campaign.data.Status ==  "010") {

                        this.hideLoading();
                        this.busSelectService.$emit('clearModal', {});
                        this.busSelectService.$emit('hideSelectBookingModal', {});

                        this.campaign.updateAfterRedeem(campaign);
                        this.initialSerialModal(campaign.data.Sequence);

                        // var self = this;
                        //     setTimeout(function () {
                        //         self.updateCampaign();
                        //     }, 1000);

                        this.hideLoading();
                        this.busSelectService.$emit('hideSelectBookingModal', {});
                    } else {

                        var errorId = campaign.data.Status;

                        var errorMessage = "";
                        switch(errorId) {

                            case "101":
                                errorMessage = this.lbl.redeem_button.error101;
                                break;
                            case "102":
                                errorMessage = this.lbl.redeem_button.cate.error102;
                                break;
                            case "103":
                                errorMessage = this.lbl.redeem_button.error103;
                                break;
                            case "104":
                                errorMessage = this.lbl.redeem_button.error104;
                                break;
                            case "105":
                                errorMessage = this.lbl.redeem_button.cate.error105;
                                break;
                            case "106":
                                errorMessage = this.lbl.redeem_button.cate.error106;
                                break;
                            case "107":
                                errorMessage = this.lbl.redeem_button.cate.error106;
                                break;
                            case "108":
                                errorMessage = this.lbl.redeem_button.cate.error108;
                                break;
                            case "109":
                                errorMessage = this.lbl.redeem_button.error109;
                                break;
                            case "201":
                                errorMessage = this.lbl.redeem_button.error201;
                                break;
                            case "202":
                                errorMessage = this.lbl.redeem_button.cate.error202;
                                break;
                            case "301":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "302":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "303":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "304":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "305":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "306":
                                errorMessage = this.lbl.redeem_button.cate.error301;
                                break;
                            case "999":
                                errorMessage = this.lbl.redeem_button.cate.error999;
                                break;
                            default:
                                errorMessage = this.lbl.redeem_button.cate.error999;
                                // code block
                        }

                        this.errorMessage = errorMessage;
                    }


                    this.hideLoading();

                }).catch((error) => {
                    console.log(error.response);
                    var tmperror = error.response.data.error;

                    var errorMessage = tmperror.message;

                    if (tmperror.id == 1) {

                        errorMessage = this.lbl.redeem_button.soldOutBooking;
                    } else if (tmperror.id == 2) {


                        if (errorMessage == 'already redeem this mastercampaign') {
                            errorMessage = this.lbl.redeem_button.alreadyRedeem;
                        } else {
                            errorMessage = this.lbl.redeem_button.longerEligible;

                        }

                    }

                    this.errorMessage = errorMessage;
                    this.hideLoading();
                    console.log(this.errorMessage);
                });
        },
        initialSerialModal: function (sequence) {
            this.serialCampaign = this.campaign;
            this.serialCampaign.serial = sequence;
            this.serialCampaign.isShowBcs = true;
            this.serialCampaign.dataInfo = this.objRedeemInfoConfig.dataInfo;

            this.busSerialModal.$emit('showSerialModal', this.serialCampaign);
        },
        Clickback: function() {
            this.$router.back();
        },
        initialCampaign: function() {
            // campaign List
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.strConfigList)
                .setCatId(this.cateId)
                .setTop(25)
                .create();
            this.listConfig = listConfig;

            this.isLoadedConfig = true;
        },
        //initial
        initialLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        getList: function() {
            console.log("privilegelist");

            this.showLoading();
            if (!this.listConfig.strConfigList) return;

            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, null)
                .then(campaigns => {

                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                    //check is there are more campaign.
                    if (campaigns &&
                        campaigns.length < this.listConfig.defaultTopAmount)
                        this.listConfig.isSeeMoreEnable = false;

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        this.listConfig.defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;

                    this.hideLoading();
                }).catch(error => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.hideLoading();
                    console.log(error);
                });
        },
        hideLoading: function () {

            this.busModal.$emit('hideLoadingModal', {});
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;

            setTimeout(() => {
                this.getList();
            }, 500);
        },
        getFormatnumber: function (price) {

            if (price) {
                return Utility.formatNum(price);
            } else {
                return this.lbl.detail.free;
            }
        },
        getCampaignPrice: function (price) {
            if (price) {
                return price;
            } else {

                return this.lbl.detail.free;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/style/base/base.scss';

.campaign-wrapper {

    padding: 15px 30px;

    .campaign-service-name {
        font-weight: bold;
        font-size: 1.3em;
        text-align: center;
    }
    .campaign-detail {
        text-align: center;
        padding-top: 10px;
    }
    .campaign-price {

        @extend %display-flex;
        margin-top: 15px;

        .icon-time {
            @extend %display-flex;
            margin-left: auto;
            margin-right: 25px;
        }
        .icon-price {
            @extend %display-flex;
            margin-right: auto;
        }
        img {
            width: 25px;
        }
        .price {
            font-size: 0.9rem;
            font-weight: bold;
            margin: auto;
        }
    }
    .booking-btn-wrapper {

        margin-top: 20px;

        .booking-btn {

            padding: 10px 15px;
            background-color: black;
            color: white;
            text-align: center;
            padding: 15px;
            font-size: 1.1rem;
            font-weight: bold;
        }
    }

    .border-item {

        padding-top: 10px;

        img {
            width: 100%;
        }
    }
}
</style>
